import { get, post } from '@/api/http'

// 获取运价
export function getFreight(params) {
  return post('/manager/eFreight/freightCenterQuery', params)
}
// 获取运价详情
export function getFreightDetail(params) {
  return post('/manager/eFreight/freightQueryMoreById', params)
  // .then(({ data }) => data)
}
// 获取整箱运价信息
export function getFclFreight(params) {
  return post('/manager/eFclFreight/freightCenterQuery', params)
}
// 获取附加费列表
export function getShippingCharge(params) {
  return get('EShippingCharge_Q', {
    params: params,
  }).then(({ data }) => {
    return {
      data: data.EShippingCharge,
      row: data.rowCount,
    }
  })
}

// 运费新增页面获取船公司附加费等
export function getAddCharge(params) {
  return get('EFreight_CQM', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 运费新增页面获取船公司附加费等
export function getTemplate(params) {
  return get('PItemplate_QC', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 模板新增明细
export function getFreightTemp(params) {
  return get('PItemplateField_Q', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 模板清单列表
export function getTempList(params) {
  return get('PItemplate_QS', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 模板编辑明细
export function getEditTemp(params) {
  return get('PItemplateMap_Q', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 模板主表信息
export function getEditTitle(params) {
  return get('PItemplate_Q', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
// 模板删除
export function removeTemp(params) {
  return get('PItemplate_R', {
    params: params,
  }).then(({ data }) => {
    return {
      data,
    }
  })
}
